export const escapeSpecialChars = (string) => string.replace(/([()[{*+.$^\\|?])/g, '\\$1');
